import {chain, uniqBy} from 'lodash';
import set from 'lodash/fp/set';

export default (state, action) => {
    if (!state) {
        state = {
            loaded: false,
            listed: [],
            indexed: {},
        };
    }

    let previous = state;

    switch (action.type) {
        case 'CHAT_ADD_SESSION':
            state = set(
                `indexed[${action.chatSessionId}]`,
                Object.assign({}, action.chatSession, {
                    messages: [],
                    messagesLoaded: true,
                    sessions: [action.chatSessionId],
                    ...(state.indexed[action.chatSessionId] || {}),
                }),
                state
            );
            break;
        case 'CHAT_UPDATE_ACTIVE_SESSIONS':
            state = Object.assign({}, state, {
                indexed: _(action.activeSessions).reduce((indexed, session) => {
                    indexed[session.id] = Object.assign(
                        {
                            messages: [],
                            messagesLoaded: false,
                            sessions: [session.id],
                        },
                        indexed[session.id],
                        session
                    );
                    return indexed;
                }, Object.assign({}, state.indexed)),
                loaded: true,
            });
            break;
        case 'CHAT_UPDATE_MESSAGES':
            // if (state.indexed[action.chatId]) {
            let messages = uniqBy([...action.messages, ...(state.indexed[action.chatId]?.messages ?? [])], 'id');
            state = set(
                `indexed.${action.chatId}`,
                Object.assign({}, state.indexed[action.chatId] ?? {}, {
                    messagesLoaded: true,
                    messages,
                    sessions: chain(messages).map('chatId').uniqBy().value(),
                }),
                state
            );
            // }
            break;
        case 'CHAT_MARK_ALL_AS_READ':
            if (state.indexed[action.chatId]) {
                state = set(
                    `indexed[${action.chatId}].messages`,
                    state.indexed[action.chatId].messages.map(message => {
                        if (!message.read) {
                            return Object.assign({}, message, {read: true});
                        }
                        return message;
                    }),
                    state
                );
            }
            break;
    }

    // Update listed version
    if (previous.indexed != state.indexed) {
        state.listed = Object.values(state.indexed);
    }

    return state;
};
